const initialState = {
  dash: [],
  isLoading: false,
}

export const dash = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DASH_LOADING':
      return {
        ...state,
        isLoading: true,
      }
    case 'GET_DASH_SUCCESS':
      return {
        ...state,
        dash: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}




